import { Component, OnInit, ViewChild, ElementRef, Input, Output, EventEmitter } from '@angular/core';
import { CommonService } from 'src/app/core/services/common.service';

@Component({
  selector: 'bt-upload-image',
  templateUrl: './upload-image.component.html',
  styleUrls: ['./upload-image.component.scss']
})
export class UploadImageComponent implements OnInit {
  @ViewChild('file') file: ElementRef<any>;
  @Input() fileImage = {
    file: null, url: null
  };
  @Input() height = '350px';
  @Output() uploadedImg = new EventEmitter<any>();
  constructor(
    private commonService: CommonService,
  ) { }

  ngOnInit(): void {
  }
  filesDropped(event) {
    this.fileImage = event;
    this.uploadedImg.emit(this.fileImage);
  }
  uploadFileClick() {
    this.file.nativeElement.click();
  }
  async onFilesAdded(event) {
    if (event) {
      const file = this.file.nativeElement.files[0];
      const url = await toBase64(file);
      this.fileImage = {
        file, url
      };
      this.uploadedImg.emit(this.fileImage);
    }
  }
}
const toBase64 = file => new Promise((resolve, reject) => {
  const reader = new FileReader();
  reader.readAsDataURL(file);
  reader.onload = () => resolve(reader.result);
  reader.onerror = error => reject(error);
});
